import BaseCard from './BaseCard';
import { CardType } from './CardType';
import GameObject from '../../../GameObject/GameObject';
import AnimationFrame from '../../../Component/AnimationFrame';
import Point from '../../../Utility/Point';
import Container from '../../Container';
import SpriteComponent from '../../../Component/Render/Sprite';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { CARD_DRAGONBONES_PATH } from 'Constants/Dragonbones';

export default class TornadoCard extends BaseCard {
    private tornado: AnimationFrame;

    public onCreate(params: any): void {
        params.cardFrontTexture = 'card_empty';
        params.type = CardType.tornado;

        // Create modifier container.
        const modifierContainer = GameObject.Instantiate(Container, {
            name: 'modifierContainer',
        });

        const tornado = GameObject.Instantiate(AnimationFrame, {
            resourceName: 'CardsVFX',
            animationName: 'tornado',
            autoStart: true,
            frameRate: 1000 / 80,
            anchor: Point.Center,
        });
        modifierContainer.addChild(tornado);
        this.tornado = tornado;

        super.onCreate(params);
        this.addChild(modifierContainer);
    }

    public updateModifiersVisibility(faceUp: boolean): void {
        super.updateModifiersVisibility(faceUp);
        this.tornado.getComponent(SpriteComponent).visible = faceUp;
    }

    public static async preload(): Promise<void> {
        addDragonbonesResources('special_card_tornado', `${CARD_DRAGONBONES_PATH}/Tornado/`);
    }
}
